import { getStoreId } from "$/hooks/use-store-information"
import serviceSettingsQueries from "$/lib/queries/service-settings-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/action-visibility")(
  {
    loader: async ({ context: { queryClient } }) => {
      const storeId = await getStoreId()
      if (storeId)
        queryClient.prefetchQuery(serviceSettingsQueries.detail(storeId))
      return {
        crumbs: "alfred.settings.nav.actionVisibility.label",
      }
    },
  },
)
